import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const assignRateSchedule = {
  name: 'assignRateSchedule',
  state: {
    loading: false,
    error: '',
  },
  reducers: {
    assignRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    assignSucceeded(state) {
      return {
        ...state,
        loading: false,
        error: '',
      };
    },

    assignFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async assignRateSchedule({ display_id, rate_schedule_id }) {
      try {
        this.assignRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const url = `savvy/displays/assign-rate-schedule`;
        const payload = {
          display_id,
          rate_schedule_id,
          user_id: userInfo.id,
          org_id : userInfo.org_id,
        };

        const response = await http.post(url, payload);

        if (response && response.data) {
          this.assignSucceeded();
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'success',
              message: 'Rate schedule assigned successfully!',
              show: true,
            },
          });
        }
      } catch (err) {
        this.assignFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
    async removeRateSchedule({ display_id }) {
      try {
        this.assignRequested();
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const url = `savvy/displays/remove-rate-schedule`;
        const payload = {
          display_id,
          user_id: userInfo.id,
          org_id : userInfo.org_id,
        };
        const response = await http.post(url, payload);

        if (response && response.data) {
          this.assignSucceeded();
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'success',
              message: 'Rate schedule removed successfully!',
              show: true,
            },
          });
        }
      } catch (err) {
        this.assignFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default assignRateSchedule;


